import router from "../routes";

export default {
    redirectToWorkerList() {
        return router.push('/staff');
    },

    redirectToLogin() {
        return router.push('/login');
    },

    redirectToAddWorker() {
        return router.push('/staff/add');
    },

    redirectToWorkerProfile(workerId) {
        return router.push('/staff/' + workerId + '/personal-information');
    },

    redirectToCarInfo(carId) {
        return router.push('/cars/' + carId + '/information');
    },

    redirectToAddCar() {
        return router.push('/cars/add');
    },

    redirectToTeam(teamId) {
        return router.push('/teams/' + teamId + '/overview');
    },

    redirectToDocument(documentId) {
        return router.push('/documents/' + documentId);
    },

    redirectToCarDocument(documentId) {
        return router.push('/cars/documents/' + documentId);
    },

    redirectToDocumentList() {
        return router.push('/documents');
    },

    redirectToUsers() {
        return router.push('/users');
    },

    redirectToAddUser() {
        return router.push('/users/add');
    },

    redirectToUser(userId) {
        return router.push('/users/' + userId);
    },

    redirectToUserInfo(userId) {
        return router.push('/users/' + userId + '/information');
    },

}
